var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
import { markRaw, createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  viewBox: "0 0 24 24",
  width: "1.2em",
  height: "1.2em"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("g", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2"
    }, [
      createElementVNode("path", { d: "M12 8v4l2 2" }),
      createElementVNode("path", { d: "M3.05 11a9 9 0 1 1 .5 4m-.5 5v-5h5" })
    ], -1)
  ]));
}
__name(render, "render");
const history = markRaw({ name: "tabler-history", render });
export {
  history as default
};
//# sourceMappingURL=history.js.map
